var _rect, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartH1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "component/btn/primary/cart_h"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 40,
    height: 40,
    rx: 15,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3215)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colour/secondary/lightCyan+75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 40,
    height: 40,
    fill: "#47D5CD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons/cart"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_3215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 24,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5037 21.9557L16.1846 21.884L16.1853 21.8839C16.6174 21.8385 17.0445 21.7937 17.4715 21.748C18.2707 21.6627 19.0697 21.5769 19.8687 21.4911L20.8087 21.3901L21.821 21.2812L21.8221 21.2811C22.4965 21.2086 23.1708 21.1361 23.8452 21.0637L24.4027 21.0037L24.403 21.0037C25.0677 20.9321 25.7323 20.8606 26.397 20.7905C26.6701 20.7617 26.9431 20.7334 27.2162 20.7052C27.7366 20.6514 28.257 20.5975 28.777 20.5401C28.82 20.5354 28.8811 20.478 28.8917 20.4349C28.9176 20.3298 28.9367 20.223 28.9557 20.1163L28.9557 20.1162C28.969 20.0415 28.9823 19.9668 28.998 19.8926C29.1843 19.0103 29.3712 18.1283 29.5582 17.2461L29.5595 17.2399L29.5611 17.2323C29.6813 16.6649 29.8016 16.0975 29.9217 15.5299C29.9717 15.294 30.021 15.0577 30.0709 14.8184L30.1425 14.4759H13.9268L15.5037 21.9557ZM11.5811 11.7147L10.92 11.7147C10.4846 11.7148 10.053 11.7148 9.62151 11.7147C9.54629 11.7147 9.47105 11.715 9.3958 11.7154H9.39578H9.39578C9.21356 11.7162 9.0313 11.717 8.84914 11.713C8.35977 11.7018 7.99401 11.3216 8.00015 10.8373C8.0065 10.3659 8.38094 10.0023 8.86819 10.0015C9.88694 9.99955 10.9057 9.99955 11.9244 10.0012C12.5562 10.0021 13.0733 10.4288 13.2029 11.0498C13.2363 11.2097 13.2703 11.3695 13.3043 11.5293L13.3043 11.5294L13.3043 11.5294C13.3785 11.8779 13.4527 12.2264 13.5206 12.5762C13.5468 12.7106 13.5943 12.7556 13.7373 12.755C14.8328 12.7503 15.9284 12.7507 17.0239 12.7512L17.9857 12.7514H22.5678L24.297 12.7514C26.0264 12.7513 27.7558 12.7512 29.4852 12.7518C29.6467 12.7519 29.8083 12.7552 29.9698 12.7586C30.267 12.7647 30.5641 12.7708 30.8602 12.7567C31.4895 12.7269 32.1419 13.3508 31.9729 14.1423C31.6606 15.605 31.3516 17.0683 31.0426 18.5316L31.0404 18.542C30.9126 19.1471 30.7848 19.7522 30.6568 20.3572L30.6002 20.6267C30.5676 20.7828 30.5349 20.9389 30.5014 21.0948C30.367 21.7218 29.9367 22.1309 29.2969 22.2046C28.4365 22.3034 27.5752 22.395 26.7139 22.4866L26.7131 22.4867C26.3734 22.5228 26.0337 22.559 25.6941 22.5955L25.2785 22.6404C24.2937 22.7465 23.3089 22.8527 22.324 22.9577C21.6674 23.0277 21.0108 23.0971 20.3542 23.1665L20.3521 23.1667C19.8246 23.2225 19.2971 23.2782 18.7697 23.3343C18.1781 23.3973 17.5864 23.4608 16.9899 23.5249L16.9874 23.5251L15.8644 23.6456L16.1023 24.784H16.3173L18.8934 24.784C22.1153 24.7842 25.3372 24.7843 28.559 24.7825C28.8538 24.7823 29.1169 24.85 29.3102 25.0822C29.542 25.3605 29.5945 25.6763 29.4372 26.0065C29.2846 26.3278 29.0213 26.4974 28.6621 26.4978C27.6028 26.499 26.5436 26.4988 25.4844 26.4986L24.2624 26.4984H20.4346L19.2767 26.4985C18.1188 26.4986 16.9609 26.4987 15.803 26.498C15.1174 26.4978 14.6166 26.0747 14.478 25.4033C14.3192 24.634 14.1563 23.8655 13.9933 23.097C13.8931 22.6245 13.7929 22.1521 13.6937 21.6795C13.6304 21.3775 13.5685 21.0752 13.5066 20.7729L13.5066 20.7728L13.5066 20.7727C13.4318 20.4076 13.3571 20.0425 13.2797 19.6779C13.0743 18.7107 12.8679 17.7436 12.6615 16.7765C12.4784 15.9189 12.2954 15.0614 12.113 14.2036C12.0065 13.703 11.9017 13.2021 11.797 12.7011C11.7396 12.4266 11.6822 12.1521 11.6245 11.8777C11.6176 11.8449 11.6085 11.8126 11.5979 11.7752L11.5979 11.7751C11.5926 11.7565 11.587 11.7366 11.5811 11.7147ZM26.5979 30.967C25.6429 30.9653 24.8851 30.2035 24.8881 29.2481C24.8911 28.2941 25.655 27.5327 26.6064 27.5357C27.5578 27.5387 28.3211 28.3053 28.3198 29.2568C28.3186 30.2067 27.5513 30.9687 26.5979 30.967ZM15.7589 29.2708C15.7608 30.2093 16.5289 30.9677 17.4767 30.9669C18.4326 30.966 19.1887 30.208 19.1891 29.25C19.1895 28.2992 18.4261 27.5364 17.4736 27.536C16.5162 27.5356 15.757 28.3035 15.7589 29.2708Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_3215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/ambient/sophia+75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/ambient/sophia"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7_2",
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#47D5CD"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 10",
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.75
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartH1X);
export default __webpack_public_path__ + "static/media/cart_h@1x.c78b08e837c8169f136a19f755fa3616.svg";
export { ForwardRef as ReactComponent };